import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { EmployeeHiresDto } from "../../../../dtos/documents/EmployeeHires/EmployeeHiresDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPosition } from "../../../Shared/NewForms/NFLookupPosition";
import { EmployeeHiresModel } from "../../../../models/Documents/EmployeeHires/EmployeeHiresModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupWorkSchedule } from "../../../Shared/NewForms/NFLookupWorkSchedule";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import EmployeeHiresDetailSkeleton from "./EmployeeHiresDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { EmployeeHiresDetailFooter } from "./EmployeeHiresDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: EmployeeHiresDto | null;
  modelUpdatedEvent: (newModel: EmployeeHiresDto) => void;
}

export const EmployeeHiresDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Employee Hires");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<EmployeeHiresModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  // const watchProducts = watch("postingOfGoodGoods");

  useEffect(() => {
    console.log(model);
    // register("postingOfGoodGoods");
    if (model) {
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("personId", model.personId);
      setValue("companyId", model.companyId);
      setValue("hireDate", model.hireDate);
      setValue("positionId", model.positionId);
      setValue("divisionId", model.divisionId);
      setValue("workScheduleId", model.workScheduleId);
      setValue("salary", model.salary);
      setValue("contractNumber", model.contractNumber);
      setValue("headId", model.headId);
      setValue("headPositionId", model.headPositionId);
      setValue("headEmployeeId", model.headEmployeeId);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: EmployeeHiresModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <EmployeeHiresDetailSkeleton />
      </>
    );
  }
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.EmployeeHires.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        {/* <NFTab title={"Products"} /> */}
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
              </Col>
              <Col sm={3}>
                <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
              </Col>
              <Col sm={3}>
                <NFDateInput title={"Hire Date"} fieldName={"hireDate"} required={true} />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
              </Col>
              <Col sm={6}>
                <NFLookupPosition fieldName={"headPositionId"} title={"Head Position"} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupPosition fieldName={"positionId"} title={"Position"} />
              </Col>
              <Col sm={6}>
                <NFLookupDivision fieldName={"divisionId"} title={"Division"} required={true} />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <NFLookupWorkSchedule fieldName={"workScheduleId"} title={"Work Schedule"} />
              </Col>
              <Col sm={6}>
                <NFTextInput title={"Contract Number"} fieldName={"contractNumber"} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
        {/* <NFTabContainer index={1} currentIndex={tabIndex}>

                    <div className={"panel-body tabs-menu-body main-content-body-right"}>
                        <NFormTable fieldArray={"customerInvoiceProducts"}>
                            <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={300} />
                            <NFIntInput fieldName={"featureId"} title={"Feature"} width={100} />
                            <NFIntInput fieldName={"unitId"} title={"Unit"} width={100} />
                            <NFIntInput fieldName={"priceTypeId"} title={"Price Type"} width={100} />
                            <NFPlainText fieldName={"productVendorCode"} title={"Product Vendor Code"} width={150} /> */}
        {/* <NFLookupFeature fieldName={"featureId"} title={"Feature"} required={true} /> */}
        {/* <NFLookupInput fieldName={"accountType"} items={accountTypes} title={"Type"} width={200} /> */}
        {/* </NFormTable>
                    </div>
                </NFTabContainer> */}

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <EmployeeHiresDetailFooter />
    </FormProvider>
  );
};
